var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobfailedrecovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32855 5.87649C9.53429 5.69819 9.548 5.38272 9.35598 5.17699L9.3697 5.16327C9.1914 4.95754 8.87593 4.94382 8.6702 5.13584L6.02307 7.56352L4.85723 6.39769C4.6515 6.20567 4.33603 6.20567 4.14401 6.39769C3.952 6.60342 3.952 6.91888 4.14401 7.1109L5.63903 8.60592C5.81733 8.79794 6.13279 8.79794 6.32481 8.61963L9.32855 5.87649Z",
    fill: "#fb8c00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90329 1.16804C6.68056 0.945303 6.32207 0.942677 6.09671 1.16804L1.16804 6.09671C0.945303 6.31944 0.942677 6.67793 1.16804 6.90329L6.09671 11.832C6.31944 12.0547 6.67793 12.0573 6.90329 11.832L11.832 6.90329C12.0547 6.68056 12.0573 6.32207 11.832 6.09671L6.90329 1.16804Z",
    stroke: "#fb8c00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobfailedrecovered);
export default __webpack_public_path__ + "static/media/Job failedrecovered.ff28a6cf1e2d63d49a5962d927c3321c.svg";
export { ForwardRef as ReactComponent };